var changeColorVariableWeight = function(variable, weight) {
    var match = variable.substring(2).match(/colors-([a-z-]+)+-(\d+)$/);
    if (!match) return variable;
    var current = Number(match[2]);
    return "--colors-".concat(match[1], "-").concat(typeof weight === "number" ? weight : weight(current));
};
export default changeColorVariableWeight;

//# sourceMappingURL=changeColorVariableWeight.js.map